module.exports = __webpack_public_path__ + "static/media/imdb.621c4151.png";